import { render, staticRenderFns } from "./InfoTypesDropdown2.vue?vue&type=template&id=04287735&scoped=true&"
import script from "./InfoTypesDropdown2.vue?vue&type=script&lang=ts&"
export * from "./InfoTypesDropdown2.vue?vue&type=script&lang=ts&"
import style0 from "./InfoTypesDropdown2.vue?vue&type=style&index=0&id=04287735&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04287735",
  null
  
)

export default component.exports